import React, { useMemo } from 'react';
import styles from './UsageUserItem.module.scss';
import ContentWithTooltip from '../ContentWithTooltip/ContentWithTooltip';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import UsageHoverLabel from '../UsageHoverLabel/UsageHoverLabel';

const UsageUserItem = ({ name, email, videos, minutes }) => {
  const { t } = useTranslation();

  const isUserDeactivated = useMemo(() => email.includes('deleted'), []);

  const userNameToTooltip = useMemo(
    () => name ?? (isUserDeactivated || !email ? t('company.settings.usage.per_user.totalVideos.no_user_name') : email),
    [name, email, isUserDeactivated]
  );

  return (
    <li className={cx(styles.itemWrapper)}>
      <ContentWithTooltip className={cx(styles.userData, { [styles.deactivated]: isUserDeactivated })} text={name} />
      <ContentWithTooltip
        className={cx(styles.userData, { [styles.deactivated]: isUserDeactivated })}
        text={isUserDeactivated ? t('company.settings.usage.per_user.deactivated_user') : email}
      />
      <UsageHoverLabel
        className={cx(styles.userData, { [styles.deactivated]: isUserDeactivated })}
        text={videos.total}
        hoverText={t('company.settings.usage.total_videos.hover', { totalVideos: videos.total, user: userNameToTooltip })}
      />
      <UsageHoverLabel
        className={cx(styles.userData, { [styles.deactivated]: isUserDeactivated })}
        text={minutes.processed}
        hoverText={t('company.settings.usage.used.hover', { used: minutes.processed })}
      />
      <UsageHoverLabel
        className={cx(styles.userData, { [styles.deactivated]: isUserDeactivated })}
        text={minutes.deleted}
        hoverText={t('company.settings.usage.deleted.hover', { deleted: minutes.deleted })}
      />
      <UsageHoverLabel
        className={cx(styles.userData, { [styles.deactivated]: isUserDeactivated })}
        text={minutes.total}
        hoverText={t('company.settings.usage.per_user.total.hover', { total: minutes.total, user: userNameToTooltip })}
      />
    </li>
  );
};

export default UsageUserItem;
